import {useEffect, useRef} from "react";

import {useRegistrationFlowRun} from "../../../auth/hooks/use_registration_flow_run";
import {isRegistrationWizardStep} from "../../../auth/state/registration_flow_slice";
import {useAppSelector} from "../../../store/hooks";

/**
 * Hook that listens for when the plan download registration flow started with the returned callback completes.
 * When the flow closes after the user got past the registration and phone steps, it triggers the callback to show
 * plan download modal, or the plan delivered callback when the plan was already opened from the unlock choice modal
 * during that flow. A flow abandoned on one of the registration or phone steps, or closed by dismissing the unlock choice,
 * reports nothing.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void, onPlanDelivered: () => void) => {
    const {isRunActive, hasRunFinished, rememberStartedRun, forgetRun} = useRegistrationFlowRun();
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const wasPlanDeliveredRef = useRef(false);
    const wasAuthCompletedRef = useRef(false);

    useEffect(() => {
        if (isRunActive) {
            wasPlanDeliveredRef.current = registrationFlowState.unlockChoiceContentDelivered;
            wasAuthCompletedRef.current = wasAuthCompletedRef.current || !isRegistrationWizardStep(registrationFlowState.currentStep);
        }

        if (hasRunFinished) {
            if (wasAuthCompletedRef.current && !registrationFlowState.unlockChoiceDismissed) {
                if (wasPlanDeliveredRef.current) {
                    onPlanDelivered();
                } else {
                    onFlowComplete();
                }
            }

            wasPlanDeliveredRef.current = false;
            wasAuthCompletedRef.current = false;
            forgetRun();
        }
    }, [
        isRunActive,
        hasRunFinished,
        registrationFlowState.unlockChoiceContentDelivered,
        registrationFlowState.currentStep,
        registrationFlowState.unlockChoiceDismissed,
        onFlowComplete,
        onPlanDelivered
    ]);

    return rememberStartedRun;
};
import {useEffect, useRef} from "react";

import {useRegistrationFlowRun} from "../../../auth/hooks/use_registration_flow_run";
import {isRegistrationWizardStep} from "../../../auth/state/registration_flow_slice";
import {useAppSelector} from "../../../store/hooks";

/**
 * Hook that listens for when the plan download registration flow started with the returned callback completes.
 * When the flow closes after the user got past the registration and phone steps, it triggers the callback to show
 * plan download modal, or the plan delivered callback when the plan was already opened from the unlock choice modal
 * during that flow. A flow abandoned on one of the registration or phone steps, or closed by dismissing the unlock choice,
 * reports nothing.
 */
export const usePlanDownloadModal = (onFlowComplete: () => void, onPlanDelivered: () => void) => {
    const {isRunActive, hasRunFinished, rememberStartedRun, forgetRun} = useRegistrationFlowRun();
    const registrationFlowState = useAppSelector((state) => state.registrationFlow);
    const wasPlanDeliveredRef = useRef(false);
    const wasAuthCompletedRef = useRef(false);

    useEffect(() => {
        if (isRunActive) {
            wasPlanDeliveredRef.current = registrationFlowState.unlockChoiceContentDelivered;
            wasAuthCompletedRef.current = wasAuthCompletedRef.current || !isRegistrationWizardStep(registrationFlowState.currentStep);
        }

        if (hasRunFinished) {
            if (wasAuthCompletedRef.current && !registrationFlowState.unlockChoiceDismissed) {
                if (wasPlanDeliveredRef.current) {
                    onPlanDelivered();
                } else {
                    onFlowComplete();
                }
            }

            wasPlanDeliveredRef.current = false;
            wasAuthCompletedRef.current = false;
            forgetRun();
        }
    }, [
        isRunActive,
        hasRunFinished,
        registrationFlowState.unlockChoiceContentDelivered,
        registrationFlowState.currentStep,
        registrationFlowState.unlockChoiceDismissed,
        onFlowComplete,
        onPlanDelivered
    ]);

    return rememberStartedRun;
};
